<template>
  <div class="recorded-info" v-if="courseInfo">
    <div class="video-box">
      <div class="back" @click="$router.back(-1)"></div>
      <div id="paler-box" v-show="!mask"></div>
      <img class="course-img" :src="courseInfo.image" v-show="mask">
      <div class="mask" @click="playVideo" v-show="mask"></div>
    </div>
    <div class="course-info">
      <p class="price" v-if="websiteData.is_course_pay==1">
        <span class="unit" v-if="courseInfo.price!='0.00'">￥</span>{{courseInfo.price=='0.00' ? '免费' : courseInfo.price}}
        <!-- <span class="original-cost" v-if="courseInfo.original_price!='0.00'">￥{{courseInfo.original_price}}</span> -->
      </p>
      <p class="course-name vertical-ellipsis">{{courseInfo.name}}</p>
      <p class="subtitle">
        <span>主讲人：<span v-for="teacher in courseInfo.teachers" :key="teacher.id">{{teacher.name}} </span><span class="dot">·</span>{{courseInfo.duration}}课时 <span class="intro" @click="showModalClick(1)">简介</span></span>
      </p>
      <div class="marks" v-if="courseInfo.tags.length>0">
        <div class="mark" v-for="tag in courseInfo.tags" :key="tag">{{tag}}</div>
      </div>
    </div>
    <div class="tab-box">
      <div class="tab-titles">
        <div class="tab-title" :class="tabIndex==2?'active':''" @click="tabOpe(2)">目录</div>
        <div class="tab-title" :class="tabIndex==1?'active':''" @click="tabOpe(1)">讲师</div>
        <div class="tab-title" :class="tabIndex==3?'active':''" @click="tabOpe(3)">评价（{{(!evaluation || evaluation.data.length==0)?0:evaluation.data.length}}）</div>
      </div>
      <div class="tab-content" v-show="tabIndex==1">
        <ul class="teachers">
          <li class="teacher" v-for="teacher in courseInfo.teachers">
            <img :src="teacher.avatar" class="teacher-img">
            <div class="teacher-content">
              <div class="teacher-name">
                <span>{{teacher.name}}</span>
                <!-- <div class="marks" v-if="teacher.tags.length>0">
                  <div class="mark" v-for="tag in courseInfo.tags" :key="tag">{{tag}}</div>
                </div> -->
              </div>
              <p class="teacher-intr">{{teacher.introduce}}</p>
              <button class="teacher-btn" @click="$router.push('/lecturerHomepage/'+teacher.id)">进入主页</button>
            </div>
          </li>
        </ul>
      </div>
      <div class="tab-content" v-show="tabIndex==2">
        <ul class="directory" v-for="(item, index) in chapterSection" :key="item.id">
          <li class="chapter" @click="$router.push('/recordedInfo/'+item.id)">
            <img :src="item.image" class="chapter-img">
            <div class="chapter-content">
              <p class="chapter-name">{{item.name}}</p>
              <p class="chapter-name"><span v-for="(teacher, index) in item.teachers" :key="index">{{teacher}} </span></p>
            </div>
          </li>
        </ul>
      </div>
      <ul class="evaluate-list" v-show="tabIndex==3">
        <li class="evaluation-btn">
          <button class="btn" @click="showModalClick(2)" v-if="websiteData.is_comment==1" >我要评价</button>
        </li>
        <li class="evaluate-info" v-for="item in evaluation.data" :key="item.id">
          <img class="user-img" :src="item.avatar || require('@/assets/head-default-personal.png')">
          <div class="evaluate-content">
            <div class="evaluate-title">{{item.name}}<span class="date">{{item.created_at}}</span></div>
            <div class="grade">
              <Star :type="'show'" :scoreNum="item.score" />
              <span class="grade-statistic">{{item.score}}分</span>
            </div>
            <div class="evaluate-text">{{item.content}}</div>
          </div>
        </li>
        <li class="evaluate-info nodata" v-if="!evaluation || evaluation.data.length==0">
          <img class="nodata-img" :src="require('@/assets/no-data.png')">
          <p class="nodata-text">暂无评价</p>
        </li>
      </ul>
    </div>
    <div class="bottom">
      <div class="collection" :class="isCollect==1?'active':''" @click="collectBtn(courseInfo.id)">收藏</div>
      <!-- <div class="share">分享</div> -->
      <div class="btns" v-if="courseInfo.is_can_play==0">
        <button class="btn try" @click="tryBtn">试听课程</button>
        <button class="btn buy" @click="payNowBtn(courseInfo.id)">立即购买</button>
      </div>
      <div class="btns" v-else>
        <button
          class="btn try disabled"
          v-if="courseInfo.is_view_restricted == 1"
        >
          立即播放
        </button>
        <button class="btn try" v-else @click="playVideo">立即播放</button>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="modal evaluation" v-show="showModal" @click="showModal=false">
        <div class="modal-content" @click.stop>
          <p class="content-title">{{modalType==1?'课程简介':'我要评价'}}</p>
          <div class="close-modal" v-if="modalType==1" @click="showModal=false"></div>
          <button v-else class="release-btn" @click="submitBtn">发布</button>
          <div v-html="courseInfo.desc" v-if="modalType==1"></div>
          <div class="grade" v-if="modalType==2">
            <span>满意度评价</span>
            <Star :type="'ope'" @returnNum='getScore' />
          </div>
          <textarea class="evaluate-text" v-model="textarea" placeholder="还有什么想说的？" v-if="modalType==2"></textarea>
          <div class="evaluate-ope" v-if="modalType==2">
            <label class="anonymity"><input type="checkbox" v-model="anonymous"> 是否匿名</label>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Star from '@/components/pc/star' //评分
import { mapMutations } from "vuex";
export default {
  name: 'recordedInfo',
  data(){
    return {
      anonymous: false,   //是否匿名
      textarea: '',       //评价内容
      score: '',          //评分
      selectId: '',
      mask: true,         //视频遮罩
      videoModal: false,
      tabIndex: 2,
      loginTip: false,    //登录提示
      courseInfo: '',     //课程详情
      chapterSection: '', //课程章节
      evaluation: '',     //评价
      isCollect: '',      //是否收藏
      player: '',         //播放器
      section: '',        //当前章节
      showModal: false,
      modalType: '',      //弹窗类型
      textarea: '',       //评价内容
      websiteData:'',
      hostLink:'',
    }
  },
  components:{
    Star
  },
  mounted(){
    this.websiteData = JSON.parse(localStorage.getItem('websiteState'))
this.hostLink = window.location.host=='localhost:8081'?'kskweb.kskstudy.com':window.location.host

    this.getCourseInfo();//获取详情
  },
  methods: {
    ...mapMutations(['ShowMLoginModal', 'CloseMLoginModal', 'ShowTipModal', 'CloseTipModal']), //登录弹窗
    //获取子组件分数
    getScore(data){
      this.score = data;
    },
    //弹窗
    showModalClick(type){
      this.modalType = type;

      if(type==2){ //评价
        if(localStorage.getItem('userInfo')){
          this.textarea = '';
          this.showModal = true;
        }else{
          this.ShowMLoginModal();
        }
      }else{
        this.showModal = true;
      }
    },
    //提交评价
    submitBtn(){
      if(this.score == 0){
        this.ShowTipModal({
          text: '请先打分'     //提示弹窗内容
        });

        return;
      }

      if(this.textarea == ''){
        this.ShowTipModal({
          text: '请填写评价内容'     //提示弹窗内容
        });

        return;
      }

      this.$axios.post(`/v1/subject/evaluation`,{
        subject_id: this.courseInfo.id,
        is_anonymous: this.anonymous?1:0,
        score: this.score,
        content: this.textarea
      }, {useLog:true}).then(res => {
        if(res.code == 0){
          let _this = this;
          this.ShowTipModal({
            text: '评论成功',     //提示弹窗内容
          });

          setTimeout(function(){
            _this.showModal = false;
            _this.getEvaluation();
          }, 2000)
        }else{
          this.ShowTipModal({
            text: res.msg     //提示弹窗内容
          });
        }
      });
    },
    //获取详情
    getCourseInfo(){
      let data = {
        subject_id: this.$route.params.id,
        host:this.hostLink
      };

      if(localStorage.getItem('user')){
        data.user_id = JSON.parse(localStorage.getItem('user')).id;
      }

      this.$axios.post(`/v1/subject/detail`, data).then(res => {
        res.data.desc = res.data.desc.replace(/<img/gi, '<img style="max-width:100%;height:auto;"');

        this.courseInfo = res.data;
        this.isCollect = res.data.is_collect;

        this.getEvaluation(); //获取评价
        this.tabOpe(2);
      });
    },
    //tab切换
    tabOpe(index){
      this.tabIndex = index;

      //获取章节
      if(index==2 && this.chapterSection == ''){
        //获取课程章节列表
        this.$axios.post(`/v1/subject/detail/courseList`,{
          subject_id: this.$route.params.id
        }).then(res => {
          let chapterSection = res.data;

          for(let i=0; i<chapterSection.length; i++){
            chapterSection[i].on = false;
          }

          this.chapterSection = chapterSection;
        });
      }
    },
    //获取评价
    getEvaluation(){
      //获取评论
      this.$axios.post(`/v1/subject/detail/evaluationList`,{
        subject_id: this.$route.params.id,
        page: 1,
        pre_page: 10
      }).then(res => {
        this.evaluation = res.data;
      });
    },
    //立即购买
    payNowBtn(id){
      //判断登录
      let userInfo = localStorage.getItem('user');

      if(userInfo){
        this.$router.push({path:'/confirmOrder/series_' + id});
      }else{
        this.ShowMLoginModal();
      }
    },
    //收藏
    collectBtn(id){
      let userInfo = localStorage.getItem('user');

      if(userInfo){
        this.$axios.post(`/v1/subject/detail/collect`, {id}, {useLog: true}).then(res => {
          if(res){
            this.isCollect = this.isCollect==1 ? 0 : 1;
          }
        });
      }else{
        this.ShowMLoginModal();
      }
    },
    //试看
    tryView(){
      this.$axios.post(`/v1/subject/detail/testPlay`,{
        subject_id: this.$route.params.id
      }).then(res => {
        let _this = this;
        this.videoModal = true;
        this.player = new Aliplayer({
          id: 'paler-box',
          width: '100%',
          height: '100%',
          source: res.data.info ? res.data.info.original_link : '',  //视频地址
          autoplay: false,
          showBarTime: 1000,
          skinLayout: [
            {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
            {name: "H5Loading", align: "cc"},
            {name: "controlBar", align: "blabs", x: 0, y: 0,
              children: [
                {name: "progress", align: "tlabs", x: 0, y: 0},   //隐藏进度条
                {name: "playButton", align: "tl", x: 15, y: 13},
                {name: "timeDisplay", align: "tl", x: 10, y: 6},
                {name: "fullScreenButton", align: "tr", x: 20, y: 12.5},
                {name: "volume", align: "tr", x: 20, y: 12.5}
              ]
            }
          ],
        }, function(player){
          player.setPreviewTime(3*60);  //试看3分钟

          //暂停播放
          player.on('pause', function () {
            if(player.getCurrentTime() >= 180 ){
              _this.ShowTipModal({
                text: '试听已结束，查看更多请购买此课程',     //提示弹窗内容
                showBtns: true,
                subBtnText: '购买',
                confirmFun: function(){
                  _this.CloseTipModal();
                  _this.payNowBtn(_this.courseInfo.id);
                }
              })
            }
          });
        });
        this.player.play();
      });
    },
    //点击视频遮罩
    playVideo(){
      if (this.courseInfo.is_view_restricted == 1) {
        this.ShowTipModal({
          text: '暂无权限观看',     //提示弹窗内容
        });
        return;
      }
      this.mask = false;
      this.tryView();
    },
    //试听按钮
    tryBtn(){
      if(this.player){
        if(this.player.getStatus() == 'pause'){
          this.player.play();
        }
      }else{
        this.playVideo();
      }
    }
  }
}
</script>
<style scoped lang="scss">
.recorded-info{
  box-sizing: border-box;
  min-height: 100vh;
  background-color: #F5F5F5;
  padding-bottom: 98px;
}
.video-box{
  height: 384px;
  position: relative;
  .back{
    width: 88px;
    height: 88px;
    background: url(~@/assets/arrows.png) center center no-repeat;
    background-size: 44px;
    transform:rotate(90deg);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .course-img{
    width: 100%;
    height: 100%;
  }
  .mask{
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    &::after{
      content: '';
      display: block;
      width: 54px;
      height: 54px;
      background: url(~@/assets/play2-ico.png) right center no-repeat;
      background-size: 100% auto;
    }
  }
}
.course-info{
  padding: 28px;
  background-color: #fff;
  .price{
    font-size: 36px;
    color: #CD1B14;
    font-weight: bold;
    .unit{
      font-size: 22px;
      font-weight: normal;
    }
    .original-cost{
      font-size: 22px;
      color: #ccc;
      font-weight: normal;
      margin-left: 14px;
      text-decoration: line-through;
    }
  }
  .course-name{
    padding-top: 28px;
    font-size: 32px;
    max-height: 88px;
    line-height: 44px;
    margin-bottom: 24px;
  }
  .subtitle{
    font-size: 26px;
    color: #999;
    .dot{
      margin: 0 16px;
    }
    .intro{
      display: inline-block;
      padding-right: 30px;
      margin-left: 28px;
      position: relative;
      &::after{
        content: '';
        display: block;
        width: 24px;
        height: 24px;
        background: url(~@/assets/arrows-right.png) right center no-repeat;
        background-size: 100%;
        transform: rotate(-90deg);
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: -10px;
      }
    }
  }
}
.marks{
  margin-top: 24px;
  .mark{
    height: 38px;
    line-height: 38px;
    padding: 0 10px;
    font-size: 24px;
  }
}
.tab-box{
  margin-top: 18px;
  background-color: #fff;
  .tab-titles{
    display: flex;
    border-bottom: 1px solid #E5E5E5;
    .tab-title{
      width: 33.33%;
      padding: 23px 0;
      font-size: 28px;
      color: #999;
      text-align: center;
      &.active{
        color: #333;
        position: relative;
        &::after{
          content: '';
          width: 40%;
          height: 4px;
          background-color: #254ED4;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          margin: 0 auto;
        }
      }
    }
  }
}
.tab-content{
  padding: 30px 26px;
}
.bottom{
  width: 100%;
  height: 98px;
  background-color: #fff;
  overflow: hidden;
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  .collection,
  .share{
    min-width: 44px;
    padding-top: 48px;
    background: url(~@/assets/star-air2-ico.png) center top no-repeat;
    background-size: 44px auto;
    font-size: 24px;
    color: #999;
    text-align: center;
    margin-left: 60px;
  }
  .collection.active{
    background: url(~@/assets/star-blue-ico.png) center top no-repeat;
    background-size: 44px auto;
  }
  .share{
    background: url(~@/assets/share.png) center top no-repeat;
    background-size: 44px auto;
    font-size: 24px;
    margin-left: 106px;
  }
  .btns{
    margin-left: auto;
    .btn{
      width: 204px;
      height: 98px;
      line-height: 98px;
      text-align: center;
      font-size: 28px;
      color: #FFF;
      float: left;
      &.try{
        background-color: #F5A623;
      }
      &.buy{
        background-color: #254ED4;
      }
      &.disabled{
        background-color: #d8d8d8;
        color: #fff;
        cursor: not-allowed;
        pointer-events: none;
      }
    }
  }
}
.evaluation-btn{
  padding: 88px 0;
  .btn{
    display: block;
    width: 136px;
    height: 44px;
    background: #9DA5BD;
    color: #fff;
    font-size: 24px;
    border-radius: 6px;
    margin: 0 auto;
  }
}
.evaluate-info{
  padding: 0 0 47px 40px;
  overflow: hidden;
  &.nodata{
    padding-left: 0;
    color: #999;
  }
}
.nodata-img{
  display: block;
  width: 576px;
  height: auto;
  margin: 0 auto;
}
.nodata-text{
  text-align: center;
}
.user-img{
  width: auto;
  height: 88px;
  border-radius: 50%;
  float: left;
}
.evaluate-content{
  width: 570px;
  float: left;
  margin-left: 24px;
}
.evaluate-title{
  font-size: 26px;
  color: #666;
  margin-bottom: 15px;
  .date{
    font-size: 24px;
    color: #999;
    float: right;
  }
}
.grade{
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
::v-deep .stars{
  .star{
    width: 24px;
    height: 24px;
    background-size: 100%;
    margin-right: 8px;
  }
}
.grade-statistic{
  font-size: 24px;
  color: #999;
  margin-left: 5px;
}
.evaluate-text{
  font-size: 28px;
  color: #333;
  line-height: 36px;
}
.modal{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 98px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 88;
  .modal-content{
    box-sizing: border-box;
    width: 100%;
    height: 600px;
    transition: height 1s;
    padding: 46px 30px;
    background-color: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
    overflow-y: auto;
    .content-title{
      font-size: 32px;
      color: #333;
      margin-bottom: 30px;
    }
    .close-modal{
      width: 100px;
      height: 100px;
      background: url(~@/assets/arrows.png) center center no-repeat;
      background-size: 50px auto;
      position: absolute;
      top: 0;
      right: 0;
    }
    .release-btn{
      width: 80px;
      height: 42px;
      font-size: 26px;
      color: #FFF;
      line-height: 42px;
      background: #9DA5BD;
      border-radius: 6px;
      position: absolute;
      top: 48px;
      right: 28px;
    }
  }
  ::v-deep .grade{
    display: flex;
    align-items: center;
    .stars{
      margin-left: 25px;
      .star{
        width: 24px;
        height: 24px;
        background-size: 100%;
      }
    }
  }
  .evaluate-text{
    box-sizing: border-box;
    width: 100%;
    height: 234px;
    padding: 20px;
    background: #F5F5F5;
    border-radius: 6px;
    font-size: 28px;
    color: #333;
    &::placeholder{
      color: #999;
    }
    
  }
}
.evaluate-ope{
  font-size: 24px;
  color: #999;
  margin-top: 24px;
  input{
    width: 24px;
    height: 24px;
  }
}
//弹出动画
.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .2s ease
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
.directory{
  .chapter{
    padding: 28px 0;
    overflow: hidden;
  }
  .chapter-img{
    width: 308px;
    height: 200px;
    border-radius: 6px;
    float: left;
  }
  .chapter-content{
    width: 366px;
    float: left;
    margin-left: 20px;
  }
  .chapter-name{
    height: 80px;
    font-size: 28px;
    color: #333333;
    line-height: 40px;
    //多行省略号
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
  }
}
.teachers{
  .teacher{
    margin-bottom: 60px;
    overflow: hidden;
  }
  .teacher-img{
    width: 158px;
    height: 208px;
    border-radius: 6px;
    float: left;
  }
  .teacher-content{
    width: 510px;
    height: 208px;
    float: left;
    margin-left: 20px;
    position: relative;
  }
  .teacher-name{
    font-size: 28px;
    color: #333;
  }
  .teacher-intr{
    height: 70px;
    padding-top: 12px;
    font-size: 26px;
    color: #999;
    line-height: 35px;
    //多行省略号
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
  }
  .teacher-btn{
    width: 128px;
    height: 42px;
    font-size: 26px;
    color: #254ED4;
    border-radius: 6px;
    border: 1px solid #254ED4;
    background: none;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>